export class Sorting{
    static stringSort<T>(items:T[],stringMapper:(T)=>string):T[]{
        let result = [...items];
        result.sort((x,y)=>{
            var xv =stringMapper(x);
            if(xv==null) xv="";
            var yv =stringMapper(y);
            if(yv==null) yv="";
            return xv.localeCompare(yv);
        });
        return result;
    } 
}